import script from "./clickOutside.vue?vue&type=script&lang=js"
export * from "./clickOutside.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__